var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (campaigns, campaignsTitle) {pug_html = pug_html + "\u003Cdiv class=\"contextual-tooltip-container\"\u003E\u003Cdiv class=\"contextual-content\"\u003E\u003Cdiv class=\"campaigns\"\u003E\u003Cdiv class=\"title\"\u003E" + (pug.escape(null == (pug_interp = campaignsTitle) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate campaigns
;(function(){
  var $$obj = campaigns;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var val = $$obj[index];
if (index < 5) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = val.CampaignName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else
if (index === 5) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = '...') ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var val = $$obj[index];
if (index < 5) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = val.CampaignName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
else
if (index === 5) {
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = '...') ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"campaigns" in locals_for_with?locals_for_with.campaigns:typeof campaigns!=="undefined"?campaigns:undefined,"campaignsTitle" in locals_for_with?locals_for_with.campaignsTitle:typeof campaignsTitle!=="undefined"?campaignsTitle:undefined));;return pug_html;};
module.exports = template;